module.exports = __webpack_public_path__ + "images/emoji/name_badge.6e0c842adfdb512f11a6.png";